/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Beneficiary = {

	deleteBeneficiary (context, contestId, beneficiaryId, onSuccess, onError, options) {
		Api.delete(context,
			"/beneficiary/beneficiary"
			+ "?contestId=" + contestId
			+ "&beneficiaryId=" + beneficiaryId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllBeneficiaries (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/beneficiary/all-beneficiaries"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, beneficiaryId, name, onSuccess, onError, options) {
		Api.put(context,
			"/beneficiary"
			+ "?beneficiaryId=" + beneficiaryId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putBeneficiary (context, contestId, name, onSuccess, onError, options) {
		Api.put(context,
			"/beneficiary/beneficiary"
			+ "?contestId=" + contestId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putDownwards (context, contestId, beneficiaryId, onSuccess, onError, options) {
		Api.put(context,
			"/beneficiary/downwards"
			+ "?contestId=" + contestId
			+ "&beneficiaryId=" + beneficiaryId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUpwards (context, contestId, beneficiaryId, onSuccess, onError, options) {
		Api.put(context,
			"/beneficiary/upwards"
			+ "?contestId=" + contestId
			+ "&beneficiaryId=" + beneficiaryId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
